import React from 'react'
import Thumbnail from 'scripts/components/thumbnail/Thumbnail'
import { soompi } from 'scripts/api/SoompiApi'
import ClientErrors from 'scripts/lib/ClientErrors'
import locale, {getLang} from 'shared/i18n/react'

class SimilarArticles extends React.Component {
  constructor(props) {
    super(props)
    this.state = {similar: null}
    this.lang = getLang()
  }

  componentDidMount() {
    const {similarCategory, postId} = this.props
    const categoryId = similarCategory ? similarCategory.id : false
    const page = 1
    const perPage = 11
    if (categoryId) {
      this.getTopicPromise = soompi.setLanguage(this.lang).getTopic('category')({id: categoryId, perPage, page})
      this.getTopicPromise.promise.then((topic) => {
        // Remove self from the list
        const posts = topic.results.filter((item) => {
          if (item.id !== postId) { return true }
        })

        if (posts.length > 0) {
          // Get 3 random items from the list
          let finalPosts = []
          this.getRandom(posts.length, 3).forEach((item) => {
            finalPosts.push(posts[item])
          })
          this.setState({similar: finalPosts})
        }
      }).catch((e) => {
        ClientErrors({
          message: 'SimilarArticles fetch failed.',
          error: e
        })
      })
    }
  }

  componentWillUnmount() {
    if (this.getTopicPromise) {
      this.getTopicPromise.cancel()
    }
  }

  getRandom(max, howMany) {
    var result = []
    if (max <= 0) { return null }
    if (max < howMany) { howMany = max }
    for (var i = 0; i < howMany; i++) {
      var num = 0
      if (max < howMany) {
        num = i
      } else {
        do {
          num = Math.ceil(Math.random() * max - 1)
        } while (result.indexOf(num) !== -1)
      }
      result.push(num)
    }
    return result
  }

  render() {
    const { similar } = this.state
    if (!similar) { return null }
    return (
      <div className="similar-article section">
        <Thumbnail
          data={similar}
          title={locale.general.similarArticle}
          titleArrow={false}
          size={4}
          limit={3}
          badgeDate={true}
          titleOnly={true}
          section="more_category"
        />
      </div>
    )
  }
}

export default SimilarArticles



// WEBPACK FOOTER //
// ./assets/js/components/article/SimilarArticles.jsx